// src/components/ScrollToTop.js
import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // Log for debugging purposes
    console.log("Route changed, scrolling to top:", pathname);
    window.scrollTo({
      top: 0,
    });

    // -- Alternative with a slight delay if needed --
    // setTimeout(() => {
    //   window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    // }, 50);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
